import React from 'react';

import { IconProps } from './types';

export const CircleXMarkSolidIcon = React.forwardRef<SVGSVGElement, IconProps>(
  (props, forwardedRef) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" ref={forwardedRef} {...props}>
      <circle cx="580" cy="580" r="390" fill="#749cfd" />
      <path
        d="M398 398c22-22 56-22 78 0l106 106 106-106c22-22 56-22 78 0s22 56 0 78l-106 106 106 106c22 22 22 56 0 78s-56 22-78 0l-106-106-106 106c-22 22-56 22-78 0s-22-56 0-78l106-106-106-106c-22-22-22-56 0-78z"
        fill="white"
      />
    </svg>
  )
);
CircleXMarkSolidIcon.displayName = 'CircleXMarkSolidIcon';

export default CircleXMarkSolidIcon;
